import React, { Component } from 'react'
 class UstoStartup extends React.Component{
    render(){
        return(
            <div>
                <p>UstoStartup</p>
            </div>
        );
    }
 }

 export default UstoStartup ; 